
'use strict'

import CustomSelect from "../../utils/CustomSelect";
import {OurTeamMember, TYPE_GRID_VIEW, TYPE_LIST_VIEW} from "./OurTeamMember";

class OurTeam{
    constructor(){
        this.main = document.getElementById('our_team');

        this._clearFilter = this.main.querySelector('.clear-filters');
        this._inputSearch = this.main.querySelector('input[name="search_practices"]');
        this._searchBtn = this.main.querySelector('a.search_btn');
        this._selectAreas = new CustomSelect(this.main.querySelector('select[name="areas"]'));
        this._selectTeamType = new CustomSelect(this.main.querySelector('select[name="team_type"]'));

        this._gridViewBtn = this.main.querySelector('.grid_view_btn');
        this._listViewBtn = this.main.querySelector('.list_view_btn');

        this._holderMembers = document.getElementById('our_team_holder_members');

        this._loadMoreBtn = document.getElementById('our_team_load_more_btn');

        this._currentPage = 1;
        this._totalPages = 0;

        this._members = [];
        
        this._currentViewType = TYPE_GRID_VIEW;

        this._timeout = null;

        this.callController = null;
                
        this._loadPage(this._currentPage);    

        this._inputSearch.addEventListener('keydown', this._onKeyDownInputSearch.bind(this));
        this._searchBtn.addEventListener('click', this._onClickSearchBtn.bind(this));
        this._selectAreas.addEventListener('change', this._onChangeSelectAreas.bind(this));
        this._selectTeamType.addEventListener('change', this._onChangeSelectTeamType.bind(this));
        this._gridViewBtn.addEventListener('click', this._onClickGridViewBtn.bind(this));
        this._listViewBtn.addEventListener('click', this._onClickListViewBtn.bind(this));
        this._loadMoreBtn.addEventListener('click', this._onClickLoadMoreBtn.bind(this));

        this._clearFilter.addEventListener('click', (e) => {
            //console.log('_clearFilter:');
            e.preventDefault();

            this._selectAreas.reset();
            this._selectTeamType.reset();
            this._inputSearch.value = '';
            this._loadPage(1);
        });
    }

    _loadPage(page){
        //console.log('_loadPage:');
        
        if(page == 1){
            this._holderMembers.innerHTML = '';
            this._members = [];
        }
        
        let params = {
            search: this._inputSearch.value,
            area: this._selectAreas.value,
            type: this._selectTeamType.value,
            page: page,
            count: page == 1, //Si es la primera carga con esos filtros pide que devuelva count pages
            lang: App.lang
        }

        let query = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        
        if (this.callController) {
            this.callController.abort();
        }
        this.callController = new AbortController();

        fetch(`${App.baseUrl}our-team/members?${query}`,{
            signal: this.callController.signal,
            headers: {
              'Cache-Control': 'no-cache'
            },
          })
        .then(response => response.json())
        .then((data)=>{
            if(page == 1){
                this._totalPages = data.total_pages;
            }

            if(this._totalPages == 0){
                this.main.classList.add('page--no-results');    
            }else{
                this.main.classList.remove('page--no-results');    
            }
            
            this._currentPage = page === 1 ? 2 : page;

            data.members.forEach((memberData, index)=>{
                let member = new OurTeamMember(memberData, this._currentViewType, index);
                this._holderMembers.appendChild(member.main);

                this._members.push(member);
            })

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)

            if(this._currentPage == this._totalPages || this._totalPages == 0 || this._totalPages == 1){
                this._loadMoreBtn.style.display = 'none';
            }else{
                this._loadMoreBtn.style.display = 'inline-flex';
            }

        })
        .catch(function(err) {
            if (err.name === 'AbortError') {
              // El error esperado por cancelación: silenciar o loguear suave
              // console.log('Solicitud cancelada'); // opcional
            } else {
              //console.error('Error inesperado:', err);
            }
          });
    }

    _onClickLoadMoreBtn(e){
        e.preventDefault();

        this._loadPage(this._currentPage + 1);
    }

    _onKeyDownInputSearch(e){
        clearTimeout(this._timeout);
        this._timeout = setTimeout(()=>{
            this._loadPage(1);
        }, 200);
    }

    _onClickSearchBtn(e){
        this._loadPage(1);
    }

    _onChangeSelectAreas(e){
        if(e.detail && e.detail.hasOwnProperty('type')){
            return;
        }
        this._loadPage(1);
    }

    _onChangeSelectTeamType(e){
        if(e.detail && e.detail.hasOwnProperty('type')){
            return;
        }
        this._loadPage(1);
    }

    _onClickGridViewBtn(e){
        e.preventDefault();

        if(this._currentViewType != TYPE_GRID_VIEW){
            this._currentViewType = TYPE_GRID_VIEW;
            
            this._gridViewBtn.classList.add('btn-square--active');
            this._listViewBtn.classList.remove('btn-square--active');
            
            this._members.forEach((member)=>{
                member.setViewType(TYPE_GRID_VIEW);
            })

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)
        }
    }

    _onClickListViewBtn(e){
        e.preventDefault();

        if(this._currentViewType != TYPE_LIST_VIEW){
            this._currentViewType = TYPE_LIST_VIEW;
            
            this._listViewBtn.classList.add('btn-square--active');
            this._gridViewBtn.classList.remove('btn-square--active');
            
            this._members.forEach((member)=>{
                member.setViewType(TYPE_LIST_VIEW);
            })

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)
        }
    }
}

export default OurTeam;
